import { Show, useContext } from 'solid-js';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import { Button } from '../../../ui-components/button/button';
import removeAmpersand from '../../../tools/remove-ampersand';

type ProductContactCardProps = {
    productTitle: string;
};

/* IFU / technical-information links. Sit in the content column right after the accordions
   (Figma "products single" 173:10819-10820). */
export const ProductFurtherLinks = () => {
    const { localize, ifuPage, productTechnicalInformationPage } = useContext(AppContext);

    const showDocs = () => Boolean(ifuPage?.url || productTechnicalInformationPage?.url);

    return (
        <Show when={showDocs()}>
            <div class="flex flex-col gap-cvi-3">
                <Show when={ifuPage?.url}>
                    <p class="body-md text-cvi-fg-default m-0">
                        {localize('view-all-our-manuals', 'View all our manuals')},{' '}
                        <a href={ifuPage.url} class="text-cvi-fg-link no-underline hover:underline">
                            {removeAmpersand(localize('go-to-ifu-instructions-for-use', 'go to IFU - Instructions For Use'))}
                        </a>
                    </p>
                </Show>
                <Show when={productTechnicalInformationPage?.url}>
                    <p class="body-md text-cvi-fg-default m-0">
                        {localize('technical-information-page', 'View technical information')},{' '}
                        <a href={productTechnicalInformationPage.url} class="text-cvi-fg-link no-underline hover:underline">
                            {removeAmpersand(localize('go-to-technical-information-for-product', 'go to Technical Information'))}
                        </a>
                    </p>
                </Show>
            </div>
        </Show>
    );
};

/* Full-width contact CTA below the two-column layout (Figma 370:8933): neutral-subtle
   surface, ds-space(13) padding on desktop, heading-4xl + primary button with arrow. */
export const ProductContactCard = (props: ProductContactCardProps) => {
    const { localize, productContactFormUrl } = useContext(AppContext);

    return (
        <Show when={productContactFormUrl}>
            <div class="flex flex-col gap-cvi-8 desktop:gap-cvi-11 rounded-cvi-md bg-cvi-bg-neutral-subtle p-cvi-section-close">
                <p class="heading-4xl font-cvi-medium text-cvi-fg-default m-0">
                    {`${localize('do-you-want-to-know-more-about-product', 'Do you want to know more about')} ${props.productTitle}?`}
                </p>
                <div class="flex flex-wrap gap-cvi-6">
                    <Button
                        label={localize('let-us-contact-you', 'Let us contact you')}
                        isLink={true}
                        iconEnd="arrow-right"
                        url={`${productContactFormUrl}?product=${props.productTitle}`}
                    />
                </div>
            </div>
        </Show>
    );
};
